<template>
  <b-tr>
    <template v-for="c in tableFields(row.isCR)">
      <b-td :key="`td-${row.id}-${c.key}`" :colspan="c.colspan" :class="[...[c.tdClass], ...[c.class]]">
        <template v-if="c.key === 'options'">
          <b-spinner v-if="spinners.isSaving" type="grow" variant="primary" />
          <b-button-group v-else class="d-flex actions-btn" size="sm">
            <b-button variant="success" @click="save()">
              <i class="fa fa-check fa-lg" />
              {{ $dt('contract-change.save', 'Save') }}
            </b-button>
            <b-button variant="warning" @click="cancel()">
              <i class="fa fa-remove fa-lg" />
            </b-button>
          </b-button-group>
        </template>
        <template v-else-if="['name'].includes(c.key)">
          <b-form-group :invalid-feedback="fErr(c.key)" :state="fErrState(c.key)">
            <b-form-input v-model="entity[c.key]" size="sm" type="text" :state="fErrState(c.key)" />
          </b-form-group>
        </template>
        <template v-else-if="['start_date'].includes(c.key)">
          <b-form-group :invalid-feedback="fErr(c.key)" :state="fErrState(c.key)" class="m-0">
            <datepicker v-model="entity[c.key]" placeholder="yyyy-mm-dd" input-class="date-input"
              wrapper-class="date-block" format="yyyy-MM-dd">
            </datepicker>
          </b-form-group>
        </template>
        <template v-else-if="['end_date'].includes(c.key)">
          <b-form-group :invalid-feedback="fErr(c.key)" :state="fErrState(c.key)" class="m-0">
            <datepicker v-model="entity[c.key]" placeholder="yyyy-mm-dd" input-class="date-input"
              wrapper-class="date-block" format="yyyy-MM-dd">
            </datepicker>
          </b-form-group>
        </template>
        <template v-else-if="['baseline_costs', 'additional_actuals', 'contract_budget'].includes(c.key)">
          <b-form-group :invalid-feedback="fErr(c.key)" :state="fErrState(c.key)" class="m-0">
            <b-input-group size="sm">
              <b-form-input v-select-on-focus v-model="entity[c.key]" :state="fErrState(c.key)" type="number"
                class="text-right" />
              <b-input-group-append is-text>{{ $dt('contract-change.currency', 'EUR') }}</b-input-group-append>
            </b-input-group>
          </b-form-group>
        </template>
        <template v-else-if="['vat_rate'].includes(c.key)">
          <b-form-group :invalid-feedback="fErr(c.key)" :state="fErrState(c.key)" class="m-0">
            <b-input-group size="sm">
              <b-form-input v-select-on-focus v-model="entity[c.key]" :state="fErrState(c.key)" type="number"
                class="text-right" />
              <b-input-group-append is-text>{{ $dt('contract-change.vat_percent', '%') }}</b-input-group-append>
            </b-input-group>
          </b-form-group>
        </template>
        <template v-else-if="['payment_due_days'].includes(c.key)">
          <b-form-group :invalid-feedback="fErr(c.key)" :state="fErrState(c.key)" class="m-0">
            <b-input-group size="sm">
              <b-form-input v-select-on-focus v-model="entity[c.key]" :state="fErrState(c.key)" type="number"
                class="text-right" />
            </b-input-group>
          </b-form-group>
        </template>
        <template v-else>{{ row[c.key] }}</template>
      </b-td>
    </template>
  </b-tr>
</template>

<script>
import merge from 'lodash.merge';
import Datepicker from 'vuejs-datepicker';
import Services from '@/services/index';

export default {
  props: {
    jira_key: { type: String, required: true },
    tableFields: { type: Function, required: true },
    row: { type: Object, required: true },
  },
  components: { Datepicker },
  data() {
    return {
      entity: this.row,
      spinners: {
        isSaving: false,
      },
      errorMsg: {},
    };
  },
  mounted() {
    if (!this.row.isCR) this.cancel();
  },
  methods: {
    cancel() {
      this.$emit('cancel');
    },
    save() {
      if (this.isEmbedded) return;
      this.spinners.isSaving = true;

      const method = this.row.id === 0
        ? Services.projects.createChangeRequest
        : Services.projects.updateChangeRequest;

      method(this.entity).then((data) => {
        this.spinners.isSaving = false;
        this.alertSuccess();
        merge(this.entity, data.data); // This will not delete keys but will preserve original object
        this.errorMsg = {};
        this.$emit('saved', this.entity);
      }).catch(({ errors, message }) => {
        this.spinners.isSaving = false;
        this.errorMsg = errors;
        this.alertError({ text: message });
      });
    },
  }
};
</script>

<style lang="scss" scoped>
input.date-input {
  text-align: center;
  border: solid 1px $gray-200;
  border-radius: 0.2rem;
  color: $gray;
  font-size: 0.76562rem;
  line-height: 1.5;
  height: calc(1.5em + 0.5rem + 2px);
  max-width: 100px;
  display: inline-block;
}

.date-block,
.date-block>div {
  text-align: center;
}
</style>
